import React, {useState, useEffect} from 'react';
import { httpGet } from '../shared/Config';
import { Button } from 'reactstrap';
import Section from '../shared/Section'
import SubscribeModal from './SubscribeModal';
import DateFormat from '../shared/DateFormat'
import moment from 'moment';
import ConfirmationModal from '../shared/ConfirmationModal';

import { useTranslation } from 'react-i18next';

function AccountManagement() {
    const {t} = useTranslation();

    const [tenant, setTenant] = useState({});
    const [accountStatus, setAccountStatus] = useState({});

    const [subscriptionInfo, setSubscriptionInfo] = useState({});
    const [subFetch, setSubFetch] = useState(false);

    const [showCancelConfModal, setShowCancelConfModal] = useState(false);
    const [showReactivateConfModal, setShowReactivateConfModal] = useState(false);

    const [subscriptionModal, setSubscriptionModal] = useState({
        open: false
    });

    function openSubscriptionModal() {
        setSubscriptionModal({open:true});
    }

    function onCancel() {
        setSubscriptionModal({open:false});
    }

    function onComplete() {
        window.location.reload();
    }

    useEffect(() => {
        async function fetchTenant() {
            try {
                const tenant = await httpGet(`/getTenant`);
                let conf = JSON.parse(tenant.data.data.configuration);
                setTenant(conf);
                console.log(conf);
                const response = await httpGet(`/orgs/accountStanding/find`);

                let accountStat;
                if(response.data) {
                    if(response.data.clientType) {
                        if(response.data.data) {
                            setAccountStatus({...response.data.data});
                            accountStat = response.data.data;
                        } else if(response.data) {
                            setAccountStatus({...response.data});
                            accountStat = response.data;
                        }
                    } else if(response.data.data) {
                        setAccountStatus({...response.data.data});
                        accountStat = response.data.data;
                    }
                }

                if(accountStat.clientType === "PERSONAL_2024" || accountStat.clientType === "TEAMS_2024") {
                    const subscriptionFetch = await httpGet(`/subscription/GLOBAL_SUB/getSubscriptionInfo`);
                    if(subscriptionFetch.data) {
                        if(subscriptionFetch.data.subInfo?.id) {
                            setSubscriptionInfo(subscriptionFetch.data.subInfo);
                        } else if(subscriptionFetch.data.error) {
                            if(subscriptionFetch.data.error === "subscription_exists") {
                                window.location.reload();
                            }
                            console.log(subscriptionFetch.data.error);
                        }
                    } else {
                        // no subscription found for this type
                    }
                }

                setSubFetch(true);
            } catch(e) {
                console.log(e);
            }
        }

        fetchTenant();
    }, []);

    function toggleCancelConfModal() {
        setShowCancelConfModal(!showCancelConfModal);
    }

    
    function cancelCancelConfModal() {
        setShowCancelConfModal(false);
    }

    function confirmCancelConfModal() {
        async function cancelSubscriptionFetch() {
            try {
                const subscriptionFetch = await httpGet(`/subscription/${subscriptionInfo.subscriptionType}/cancelSubscription`);
                if(subscriptionFetch) {
                    setTimeout(() => {
                        window.location.reload();
                    }, 2000);
                }
            } catch(e) {
                console.log(e);
            }
        }

        cancelSubscriptionFetch();
    }

    function toggleReactivateConfModal() {
        setShowReactivateConfModal(!showCancelConfModal);
    }

    
    function cancelReactivateConfModal() {
        setShowReactivateConfModal(false);
    }

    function confirmReactivateConfModal() {       
        async function reactiveCurrentSubscriptionFetch() {
            try {
                const subscriptionFetch = await httpGet(`/subscription/${subscriptionInfo.subscriptionType}/reactivateSubscription`);
                if(subscriptionFetch) {
                    setTimeout(() => {
                        window.location.reload();
                    }, 2000);
                }
            } catch(e) {
                console.log(e);
            }
        }

        reactiveCurrentSubscriptionFetch();
    }


    return (
        <div>
            <h2>
                <b>{t('ACCOUNT_MANAGEMENT')}</b>
            </h2>
            <Section>
                <div lassName="row justify-content-around">
                    <div>{t('ACCOUNT_MANAGEMENT_SECTION')}</div>
                    <br/>
                    {t('ACCOUNT_TYPE')}: {accountStatus.uiClientType}
                    <br/>
                    {
                        accountStatus.clientType === "PERSONAL_2024" || accountStatus.clientType === "TEAMS_2024" ? <React.Fragment>
                            {
                                subFetch && subscriptionInfo.id ? <React.Fragment>
                                    {
                                        subscriptionInfo.active ? 
                                        <React.Fragment>                 
                                            <br/>
                                            {t('SUBSCRIPTION_ACTIVE')}                    
                                            <br/>
                                            {t('SUBSCRIPTION_START_DATE')}: <DateFormat>{moment(subscriptionInfo.dateSubscriptionStarts)}</DateFormat>hrs
                                            <br/> 
                                            {t('MODE')}: {t(subscriptionInfo.subscriptionMode)}    
                                            <br/>
                                            {
                                                subscriptionInfo.dateSubscriptionEnds ?  
                                                <React.Fragment>
                                                    {
                                                        subscriptionInfo.status === "ACTIVE"  ? <React.Fragment>
                                                            {t('SUBSCRIPTION_BILLING_DATE')}: <DateFormat>{moment(subscriptionInfo.dateSubscriptionEnds)}</DateFormat>hrs
                                                        </React.Fragment>
                                                            : null
                                                    } 
                                                    {
                                                        subscriptionInfo.status === "ACTIVE_NO_RENEWAL" ? <React.Fragment>
                                                            {t('SUBSCRIPTION_START_END')}: <DateFormat>{moment(subscriptionInfo.dateSubscriptionEnds)}</DateFormat>hrs
                                                        </React.Fragment>
                                                            : null
                                                    }
                                                </React.Fragment> : null
                                            }
                                        </React.Fragment> : 
                                        <React.Fragment>
                                            {t('SUBSCRIPTION_INACTIVE')}
                                            <br/>
                                            <br/>
                                            {
                                                subscriptionInfo.status === "CANCELLED" || (subscriptionInfo.subscriptionPayMethod === "STRIPE" && !subscriptionInfo.stripeSubscriptionId) ?
                                                <React.Fragment>
                                                <Button color="primary" onClick={openSubscriptionModal}>{t('SUBSCRIBE')}</Button>
                                                <br/>
                                                <SubscribeModal 
                                                        isOpen={subscriptionModal.open} 
                                                        onCancel={onCancel}
                                                        askFacturacion={false}
                                                        existingSubscription={subscriptionInfo}
                                                        subscriptionType={accountStatus.clientType}
                                                        tenant={tenant}
                                                        onComplete={onComplete}
                                                        title="SUBSCRIPTION"
                                                    />    
                                                </React.Fragment> : null 
                                            }
                                        </React.Fragment>
                                    }                 
                                    <br/>
                                    {
                                        subscriptionInfo.status === "ACTIVE" ? <React.Fragment>
                                        <Button style={{marginTop: '10px'}} color="primary" onClick={toggleCancelConfModal}>{t('CANCEL_SUBSCRIPTION')}</Button>
                                        <br/>                  
                                        <br/> 
                                        <ConfirmationModal isOpen={showCancelConfModal}
                                            onCancel={cancelCancelConfModal}
                                            onOk={confirmCancelConfModal}
                                            title="CANCEL_SUBSCRIPTION">
                                                <span>{t('CANCEL_SUBSCRIPTION_NOTICE_1')}</span>
                                                <br/>
                                                <p>{t('CONTINUE_QUESTION')}</p>
                                        </ConfirmationModal>
                                        </React.Fragment> : null
                                    }
                                    {
                                        subscriptionInfo.status === "ACTIVE_NO_RENEWAL" ? <React.Fragment>
                                            <br/>
                                            {t('REACTIVATE_SUBSCRIPTION_NOTICE_1')}
                                            <br/>       
                                            <br/>
                                            <Button color="primary" onClick={toggleReactivateConfModal}>{t('REACTIVATE_SUBSCRIPTION')}</Button>
                                            <br/>                                
                                            <ConfirmationModal isOpen={showReactivateConfModal}
                                                onCancel={cancelReactivateConfModal}
                                                onOk={confirmReactivateConfModal}
                                                title="REACTIVATE_SUBSCRIPTION">
                                                    <span>{t('REACTIVATE_SUBSCRIPTION_NOTICE_2')}</span>
                                                    <br/>
                                                    <p>{t('CONTINUE_QUESTION')}</p>
                                            </ConfirmationModal>
                                        </React.Fragment> : null
                                    }
                                </React.Fragment> : <React.Fragment>
                                    Obteniendo informacion de suscripción...
                                </React.Fragment>
                            }
                        </React.Fragment> : null
                    }

                    {
                        accountStatus.clientType === "CORPORATIVO" ? <React.Fragment>

                        </React.Fragment> : null
                    }
                    
                </div>
            </Section>
        </div>
    )
}

export default AccountManagement;